<div class="profile-item" [class.transparent]="isStory">
  <div class="profile-picture big-profile-picture" >
    <img src="{{profilePic}}" appImageFallback>
  </div>
</div>
